import React from 'react';
import './CustomersSection.scss';
import Container from 'reactor/components/Grid/ContainerWithWidth';
import BoxItem from 'reactor/components/Box';
import Image from 'reactor/components/Image';
import Slider from "react-slick";
import Heading from "./../../components/heading";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import demi from 'assets/images/clients/demi.webp';
import vita from 'assets/images/clients/vita.webp';
import qassim from 'assets/images/clients/qassim.webp';
import aljazirah from 'assets/images/clients/aljazirah.webp';
import goStation from 'assets/images/clients/go-station.webp';
import alawasem from 'assets/images/clients/alawasem.webp';
import almqr from 'assets/images/clients/almqr.webp';
import masafy from 'assets/images/clients/masafy.webp';
import sared from 'assets/images/clients/sared.webp';
import mohtwize from 'assets/images/clients/mohtwize.webp';
import rowaak from 'assets/images/clients/rowaak.webp';
import effah from 'assets/images/clients/effah.webp';
import saudinetlink from 'assets/images/clients/saudinetlink.webp';
import momrah from 'assets/images/clients/momrah.gov.webp';

// SwiperCore.use([ Pagination ]);
var settings = {
    dots: true,
    arrows: false,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    rtl: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 425,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
    ],
};
const customersList = [
    {
        id: 1,
        title: 'DEMI',
        img: demi
    },
    {
        id: 2,
        title: 'VITA',
        img: vita
    },
    {
        id: 3,
        title: 'Qassim Health Cluster',
        img: qassim
    },
    {
        id: 4,
        title: 'Aljazirah Falcon',
        img: aljazirah
    },
    {
        id: 5,
        title: 'Go Station',
        img: goStation
    },
    {
        id: 6,
        title: 'Alawasem',
        img: alawasem
    },
    {
        id: 7,
        title: 'Almqr',
        img: almqr
    },
    {
        id: 8,
        title: 'Masafy',
        img: masafy
    },
    {
        id: 9,
        title: 'Sared',
        img: sared
    },
    {
        id: 10,
        title: 'Mohtwize',
        img: mohtwize
    },
    {
        id: 11,
        title: 'Rowaak',
        img: rowaak
    },
    {
        id: 12,
        title: 'Effah',
        img: effah
    },
    {
        id: 13,
        title: 'Saudinetlink',
        img: saudinetlink
    },
    {
        id: 14,
        title: 'Momrah.gov',
        img: momrah
    },
]

export default function Customers() {

    return (
        <div id="customers__section">
            <Container block={"true"}>
                <Heading title="عملائنا"
                    subtitle="عملاء تشرفنا بخدمتهم. كن أنت  التالي."
                />
                <Slider {...settings}>
                    { customersList.map( customerItem => (
                        <BoxItem key={customerItem.id} className="customer__item">
                            <Image src={customerItem.img} alt={customerItem.title} />
                        </BoxItem>
                    )) }
                </Slider>
            </Container>
        </div>
    )
}